import { filterWorksSeries, stripWorksExport } from "@utils/worksReceivables";

// Compatibility exports for Works; no capability opens revenue in this surface.
export const receivablesStateOrLegacy = () => "restricted";
export const filterReceivablesSeries = (series) => filterWorksSeries(series);
export const filterReceivablesExport = (data) => stripWorksExport(data);
